export default "__VITE_ASSET__CHkJjTGJ__"